import type { App } from 'vue'
import { setRatio, getEm, setMedia, getMedia } from '@touchvue/utils'
import * as TouchVueComponents from '@touchvue/components'
import InstallDirective from '@touchvue/directives'
// 添加语言包导入
import { use as useTouchvueLocale } from '@touchvue/locale'
import cnTouchvueLocale from '@touchvue/locale/lang/zh-CN.js'
import enTouchvueLocale from '@touchvue/locale/lang/en-US.js'

export interface TouchVueUIOptions {
	ratio?: {
		base?: {
			pc?: number
			pad?: number
			phone?: number
		}
	}
	zIndex?: number
	input?: {
		spChars?: string
	}
	// 添加语言配置选项
	lang?: string
}

// 全局默认配置
export const defaultOptions: TouchVueUIOptions = {}

// 全局配置
export let globalOptions = { ...defaultOptions }

// 获取全局配置
export const getGlobalOptions = (): TouchVueUIOptions => {
	return globalOptions
}

const install = (app: App, options: TouchVueUIOptions = {}) => {
	// 合并配置项
	globalOptions = {
		...defaultOptions,
		...options
	}

	// 处理国际化配置
	const lang = options.lang || 'zh-CN'
	let localeModule
	if (lang === 'en-US') {
		localeModule = enTouchvueLocale
	} else if (lang === 'zh-CN') {
		localeModule = cnTouchvueLocale
	} else {
		// 如果是其他语言，尝试从默认语言包开始，用户可能需要自己提供
		localeModule = cnTouchvueLocale
	}
	// 设置默认语言
	useTouchvueLocale(localeModule)

	// 将配置注入到应用实例中，可以通过app.config.globalProperties.$TOUCHVUE_CONFIG访问
	// 工具
	app.config.globalProperties.$getEm = getEm
	app.config.globalProperties.$setMedia = setMedia
	app.config.globalProperties.$getMedia = getMedia

	const media = getMedia()
	app.config.globalProperties.$phone = media === 'phone'
	app.config.globalProperties.$pad = media === 'pad'
	app.config.globalProperties.$pc = media === 'pc'

	// 全局默认配置
	app.config.globalProperties.$TouchUI = {
		zIndex: globalOptions.zIndex || 2000, // 全局zIndex基数
		input: globalOptions.input || {}
	}
	;(window as any).$TouchUI = {
		zIndex: 2000
	}
	// 初始化
	setMedia(options)
	setRatio(options)

	// 注册所有组件
	Object.values(TouchVueComponents).forEach(component => {
		// 确保是有效的Vue组件插件
		if (component && typeof component === 'object' && 'install' in component && typeof component.install === 'function') {
			app.use(component as any)
		}
	})

	InstallDirective.install(app)
}

// export { install };

export default install

export * from '@touchvue/components'
export * from '@touchvue/directives'
export * from '@touchvue/locale'
export * from '@touchvue/utils'
export * from '@touchvue/hooks'
